<mat-card class="category-card slim-category-card">
  <div mat-card-image class="product-image" [style.background]="'url(' + doc.imageUrl + ')'" alt=""></div>
  <mat-card-footer class="text-left">
    <mat-card-title class="text-left text-overflow-ellipsis-desktop-only categoryTitle" >
      {{doc.name}}
    </mat-card-title>
  </mat-card-footer>
</mat-card>
